var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFavorites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#e3e3e3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330.67-255.5 480-345l149.33 90.33L589.5-424l131.67-114-173.34-15.5-67.83-160L412.5-554l-173.33 15 131.66 113.83-40.16 169.67ZM480-271 299.83-162.33q-8.83 5.5-18.41 4.83-9.59-.67-16.75-6.17-7.17-5.5-11-13.83-3.84-8.33-1.17-19L300-401.67 141-540q-8.17-7.17-10.17-16.08-2-8.92.5-17.59 2.5-8.66 9.92-14.5 7.42-5.83 17.92-7l210-18.33L450.83-807q4-9.5 12.17-14.33 8.17-4.84 17-4.84t17 4.84q8.17 4.83 12.5 14.33l81.67 193.5 210 18.33q10.16 1.17 17.58 7 7.42 5.84 9.92 14.5 2.5 8.67.5 17.59-2 8.91-10.17 16.08L660-401.67l47.83 205.17q2.34 10.67-1.5 19-3.83 8.33-11 13.83-7.16 5.5-16.75 6.17-9.58.67-18.08-4.83L480-271Zm0-203Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFavorites);
export default __webpack_public_path__ + "static/media/add-favorites.3f8af53b694e256891225952dbd6375a.svg";
export { ForwardRef as ReactComponent };